module.exports = __webpack_public_path__ + "static/crtifailpreview-a65beecdf9ff8e9597bf608d74a9eef6.jpg";